import { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import {
	useGetOnboardingState,
	deserializeState,
	useSetOnboardingState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';
import { ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';

export const useAdminFeedbackSurvey = () => {
	const { data, loading, error } = useGetOnboardingState(
		ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS.PRESENCE_ADMIN_FEEDBACK_SEEN,
	);
	const { setOnboardingState } = useSetOnboardingState();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		if (loading || !error) {
			return;
		}
		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				source: 'adminFeedbackSurvey',
				actionSubject: 'AdminFeedbackSurvey',
				action: 'failed to get hasAdminSeenFeedbackSurvey',
				attributes: {
					error,
				},
			},
		}).fire();
	}, [loading, error, createAnalyticsEvent]);

	const { hasAdminSeenFeedbackSurvey } = deserializeState(data);

	const setAdminFeedbackSurveyViewed = () =>
		setOnboardingState({
			key: ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS.PRESENCE_ADMIN_FEEDBACK_SEEN,
			value: 'true',
		});

	return {
		hasAdminSeenFeedbackSurvey: Boolean(hasAdminSeenFeedbackSurvey),
		setAdminFeedbackSurveyViewed,
	};
};
